import PropTypes from "prop-types"

export const TRADE = PropTypes.shape({
  key: PropTypes.string.isRequired,
  ticker: PropTypes.string.isRequired,
  mic: PropTypes.string.isRequired,
  country: PropTypes.string,
  label: PropTypes.string.isRequired,
  tradePercentDelta: PropTypes.number.isRequired,
  securityPercentEquity: PropTypes.number.isRequired,
})
